import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  trialBannerText: (period: string) =>
    `You have ${period} left in your trial, check `,
  trialBannerButton: 'our plans to sign up',
  check: 'Check ',
  day: 'day',
  hour: 'hour',
};

const welsh = {
  trialBannerText: (period: string) =>
    `Mae gennych ${period} ar ôl yn eich cyfnod prawf, gwiriwch `,
  trialBannerButton: 'ein cynlluniau i gofrestru',
  check: 'Gwiriwch ',
  day: 'diwrnod',
  hour: 'awr',
};

export const trialBannerText: any = getLocalizationBasedOnLang(english, welsh);
